import {useHostName} from 'presentation/hooks';
import {useReverseNetworkOrder} from 'presentation/hooks/useReverseNetworkOrder';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {useBookingSummary} from 'presentation/modules/booking/shared/hooks/useBookingSummary';

import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {Unit} from 'presentation/modules/booking/shared/store/useUnitsListStore/types';
import {useMediaQueries, useQueryParams} from 'presentation/pages';

export function useExamUnitsAccreditedNetwork(unitsList: Unit<FlowEnum.EXAM>) {
	const {isMobile} = useMediaQueries();
	const {isGndiSaoPaulo} = useHostName();
	const {shouldReverseNetworkOrder} = useReverseNetworkOrder({flowType: 'EXAM'});

	const {specialtyName} = useBookingStore(state => state.bookingData);
	const {
		SEARCH_PARAMS: {query},
	} = useQueryParams();
	const {handleChangeModals} = useBookingSummary();

	const listByDistanceIsEmpty = unitsList.units.unitsByDistance?.length === 0;
	const listByLocalityIsEmpty = unitsList.units.unitsByLocality?.length === 0;
	const hideDivider =
		(listByDistanceIsEmpty && listByLocalityIsEmpty && query) || !isGndiSaoPaulo;

	const listIsEmpty = unitsList.units.unitsSupportAccredited.length === 0;

	return {
		isMobile,
		specialtyName,
		query,
		handleChangeModals,
		hideDivider,
		listIsEmpty,
		shouldReverseNetworkOrder,
	};
}
